import React from 'react';
import clsx from 'clsx';

interface GridProps {
  children: ReactChildren;
  className?: string;
}

const Grid = ({ children, className }: GridProps) => (
  <div
    className={clsx(
      'tw-grid tw-gap-4 tw-pr-16 tw-ml-8',
      'tw-grid-cols-[repeat(2,minmax(20rem,36rem))]',
      'chromebook-plus:tw-grid-cols-[repeat(3,minmax(20rem,36rem))]',
      className,
    )}
  >
    {children}
  </div>
);

export default Grid;
